export enum ETransportType {
  Transport = 'transport',
  Walk = 'walk',
}
